import React, { useState, useEffect } from 'react';
import {
  Briefcase,
  Users,
  MapPin,
  ShieldCheck,
  Handshake,
  Building2,
} from 'lucide-react';
import AboutImg from '../../Files/about-page-main-image-first-brick.png';

const AnimatedCounter = ({ target, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const step = Math.ceil(target / (duration / 16));

    const interval = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 16);

    return () => clearInterval(interval);
  }, [target]);

  return (
    <div className="about-page-fb-counter">
      <h3>{count}+</h3>
      <p>{label}</p>
    </div>
  );
};

const AboutUs = () => {
  return (
    <section className="about-page-fb">
      {/* Header */}
      <div className="about-page-fb-header">
        <h1>About Get Propertys</h1>
        <p>
          Over 5 years of trusted service in real estate and insurance – guided
          by integrity, professionalism, and transparency.
        </p>
      </div>

      {/* Hero Image */}
      <div className="about-page-fb-hero-image">
        <img src={AboutImg} alt="Get Propertys Office View" />
      </div>

      {/* Main Content */}
      <div className="about-page-fb-main">
        <div className="about-page-fb-content">
          {/* Company Overview */}
          <div className="about-page-fb-section black-section">
            <h2>
              <Building2 size={22} /> Company Overview
            </h2>
            <p>
              At Get Propertys, we bring over 5 years of experience in both real
              estate and insurance services. Whether you're buying, selling,
              investing, or insuring, we deliver personalized solutions with
              complete transparency and ethical guidance.
            </p>
            <p>
              Our expertise spans the sale, purchase, and rental of flats,
              shops, and commercial properties — along with reliable land deals
              and property consulting for investors and businesses.
            </p>
            <p>
              Backed by <strong>MAHA RERA Registration No. A011242400062</strong>, we assure every transaction is secure, legal, and professionally handled. From residential to commercial investments, our team ensures hassle-free, end-to-end support.
            </p>
          </div>

          {/* Mission */}
          <div className="about-page-fb-section gold-section">
            <h2>
              <Handshake size={22} /> Our Mission
            </h2>
            <p>
              To empower our clients with dependable property and insurance
              solutions — building long-term relationships through trust,
              transparency, and results.
            </p>
            <p>
              We strive to be your one-stop destination for real estate and
              insurance, simplifying decisions and maximizing value.
            </p>
          </div>

          {/* Core Values */}
          <div className="about-page-fb-section black-section">
            <h2>
              <ShieldCheck size={22} /> Core Values
            </h2>
            <ul>
              <li>
                <ShieldCheck size={18} /> Integrity – We work honestly and fairly in every deal.
              </li>
              <li>
                <Briefcase size={18} /> Professionalism – Delivering services with skill and accountability.
              </li>
              <li>
                <Users size={18} /> Client First – We prioritize your goals and peace of mind.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="about-page-fb-trust-badges">
        <h2 className="about-page-fb-trust-heading">
          Why Clients Trust Get Propertys
        </h2>
        <div className="about-page-fb-badges-grid">
          <div className="about-page-fb-badge">
            <ShieldCheck size={28} />
            <p>RERA Registered</p>
          </div>
          <div className="about-page-fb-badge">
            <Handshake size={28} />
            <p>End-to-End Support</p>
          </div>
          <div className="about-page-fb-badge">
            <Users size={28} />
            <p>Reliable Guidance</p>
          </div>
          <div className="about-page-fb-badge">
            <Briefcase size={28} />
            <p>Trusted by Investors</p>
          </div>
        </div>
      </div>

      {/* Counters */}
      <div className="about-page-fb-counters">
        <AnimatedCounter target={5} label="Years of Experience" />
        <AnimatedCounter target={250} label="Properties Handled" />
        <AnimatedCounter target={2} label="Office Locations" />
      </div>

      {/* Quote */}
      <div className="about-page-fb-founder-quote">
        <blockquote>
          <p>
            "We don’t just deal in properties, we deal in trust, transparency,
            and a better future for every client."
          </p>
          <footer>
            <cite>- Get Propertys</cite>
          </footer>
        </blockquote>
      </div>
    </section>
  );
};

export default AboutUs;
